"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
// Ticket/Approval/Team/Vendor view-model types moved here from Trackly.WebClient's per-service
// `types.ts` files (T011-T014).
__exportStar(require("./accessRequest"), exports);
__exportStar(require("./asset"), exports);
__exportStar(require("./ticket"), exports);
__exportStar(require("./approval"), exports);
__exportStar(require("./team"), exports);
__exportStar(require("./vendor"), exports);
__exportStar(require("./dimension"), exports);
__exportStar(require("./featureFlag"), exports);
__exportStar(require("./releaseNotes"), exports);
__exportStar(require("./user"), exports);
__exportStar(require("./workflow"), exports);
